/*
 * @Descripttion: 
 * @version: 
 * @Author: dengyao
 * @Date: 2023-11-27 13:33:12
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-11-28 11:31:18
 */
import request from '../request'
const { VITE_APP_API_BASE_URL, VITE_APP_I18N_URL } = import.meta.env
const GET_I18N = VITE_APP_I18N_URL + '/sysInternational/getSysInternationalList'
enum Api {
  GET_LIST = '/dict/listDictValue'
}

export default class dictService {
  /**
   * 获取字典
   * @param data
   * @returns
   */
  static getList(data: any): Promise<any> {
    return request.get(Api.GET_LIST, data)
  }
  /**
   * 获取i18n数据
   * @param data
   * @returns
   */
  static getI18n(data: any): Promise<any> {
    return request.get(GET_I18N, data)
  }
}
